import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AllBookings from './AllBookings';
import '../styles/AdminPanel.css';
import RoomRates from './RoomRates';

const AdminPanel = () => {
  const [bookings, setBookings] = useState(false);
  const [rooms, setRooms] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const storedToken = localStorage.getItem('admin-auth-token');
    if (!storedToken) {
      navigate('/admin_login_page');
    }
  }, [navigate]);

  return (
    <div className="admin-panel">
      <h1>Admin Dashboard</h1>

      <div className="admin-actions">
        <button className={`admin-btn ${bookings ? 'active' : ''}`} onClick={() => {setBookings(true); setRooms(false)}}>View Bookings</button>
        <button className={`admin-btn ${rooms ? 'active' : ''}`} onClick={() => {setRooms(true); setBookings(false)}}>Change Room Rates</button>
      </div>

      <div className="admin-content">
        {bookings ? <AllBookings /> : rooms ? <RoomRates/> : <p className="no-selection">Select an option to view details</p>}
      </div>
    </div>
  );
};

export default AdminPanel;
